import { Button, toast } from '@hemmafixa/ui';
import { Bookmark, BookmarkCheck } from 'lucide-react';
import { useI18n } from '@/i18n/context';
import { useSaveJob } from './api';

interface SaveJobButtonProps {
  jobId: string;
  saved: boolean;
  /** Icon only, for job cards; the label is still read out */
  compact?: boolean;
}

/** Saves a job to come back to, or removes it from Saved (P4-03). */
export function SaveJobButton({ jobId, saved, compact = false }: SaveJobButtonProps) {
  const { t } = useI18n();
  const save = useSaveJob();
  const f = t.provider.findJobs;
  const label = saved ? f.unsave : f.save;
  const Icon = saved ? BookmarkCheck : Bookmark;

  return (
    <Button
      variant={compact ? 'ghost' : 'outline'}
      size={compact ? 'icon' : 'md'}
      aria-pressed={saved}
      aria-label={compact ? label : undefined}
      title={compact ? label : undefined}
      loading={save.isPending}
      onClick={(event) => {
        // Sits on a card whose title link covers it; the click is only for this button
        event.stopPropagation();
        save.mutate(
          { id: jobId, saved: !saved },
          {
            onSuccess: () => toast.success(saved ? f.unsavedToast : f.savedToast),
            onError: () => toast.error(t.common.errorMessage),
          },
        );
      }}
    >
      <Icon aria-hidden />
      {!compact && label}
    </Button>
  );
}
